import React from 'react';
import './Maintenance.css';
import logo from './Images/logo.png';

function Maintenance() {
    return (
        <div className="maintenanceWrapper">
            <div className="maintenanceCard">
                <img src={logo} alt="Claim Suvidha" className="maintenanceLogo" />

                <div className="maintenanceIcon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l2.3-2.3a5 5 0 0 1-6.6 6.6l-6.1 6.1a2 2 0 1 1-2.8-2.8l6.1-6.1a5 5 0 0 1 6.6-6.6l-2.3 2.3z"
                            stroke="#007bff"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <p className="maintenanceEyebrow">Scheduled Maintenance</p>
                <h1 className="maintenanceHeading">We'll be back shortly</h1>
                <p className="maintenanceText">
                    We're currently making a few improvements behind the scenes to serve you better.
                    Our website is temporarily unavailable, but we'll be back online soon.
                </p>
                <p className="maintenanceSubtext">
                    Thank you for your patience.
                </p>

                <div className="maintenanceDivider" />

                <div className="maintenanceContact">
                    <p className="maintenanceContactLabel">Need urgent assistance?</p>
                    <a href="mailto:info.claimsuvidha@gmail.com" className="maintenanceContactLink">
                        info.claimsuvidha@gmail.com
                    </a>
                    <a
                        href="https://wa.me/918789384248"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="maintenanceContactLink"
                    >
                        WhatsApp: +91 87893 84248
                    </a>
                </div>
            </div>

            <p className="maintenanceFooter">&copy; {new Date().getFullYear()} Claim Suvidha. All rights reserved.</p>
        </div>
    );
}

export default Maintenance;
